export enum NewmAlertEnum {
    SUCCESS,
    ERROR,
    WARNING,
    INFORMATION
}
